export default {
  timeout: 60000,
  page_size: 20,
};
